import React, { Component }  from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  onCreateDepartment
} from '../../redux/department/action'  
import styles from './Departments.module.scss'
import { 
  Row,
  Col,
  Divider,
  Button,
  Input,
  Form,
  message
} from 'antd'

class AddForm extends Component {
  constructor(props){
    super(props)
    this.state = {
      createDepartment: { name: null }
    }
  }
  onGenerateDepartment = (e) => { 
    const { onCloseModal,onCreateDepartment,fetch } = this.props
    e.preventDefault() 
    this.props.form.validateFieldsAndScroll( async(err, values) => {   
      if(!err){ 
        await onCreateDepartment(values)
        message.success('เพิ่มสังกัดโรงเรียนสำเร็จ')
        await fetch()
        onCloseModal()
      }
    })
  }
  render(){
    const { onCloseModal,form: { getFieldDecorator } } = this.props 
    return (
      <Form onSubmit={this.onGenerateDepartment} hideRequiredMark={true}>
        <h1 className={styles.header_modal}>เพิ่มข้อมูล</h1>
        <Row >
          <Col offset={4} span={16}  > 
            <Form.Item label='สังกัดของโรงเรียน/หน่วยงาน'>
              {
                getFieldDecorator('name',{
                  rules: [ 
                    {
                      required: true,
                      min: 1,
                      message: 'กรุณากรอกสังกัดของโรงเรียน/หน่วยงาน',
                    }, 
                  ],
                  initialValue: ''
                })(<Input/>)
              }
            </Form.Item> 
          </Col> 
        </Row>
        <Divider/>
        <Row>
          <Col span={12}>
            <span onClick={e => {e.stopPropagation(); onCloseModal()}} style={{ cursor:'pointer', color:'#828282', textDecorationLine: 'underline'}}>ยกเลิก</span>
          </Col>
          <Col span={12}>
            <Button htmlType='submit' type='primary' className={ styles.button_save_modal }>เพิ่มข้อมูล</Button>
          </Col>
        </Row> 
      </Form>
    )
  }
}

const mapStateToProps = () => {
  return {   
    
  }
}
const mapDispatchToProps = dispatch => 
  bindActionCreators(
    {   
      onCreateDepartment
    },
    dispatch
  )
 
const WrappedFormDataSchool = Form.create({ name: 'Add_Form_Department' })(AddForm)
export default connect(mapStateToProps,mapDispatchToProps)(WrappedFormDataSchool)
